import React from "react"
import PropTypes from "prop-types"
import createReactClass from "create-react-class"

import appStorage from "@cirrus/legacy/app-components/app-settings/index.es6"

export default createReactClass({
  propTypes: {
    tkey: PropTypes.string.isRequired,
    className: PropTypes.string,
  },
  translate() {
    return appStorage.translationFunction(this.props.tkey)
  },
  render() {
    return <span className={this.props.className}>{this.translate()}</span>
  },
})
